var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutputLang = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6C13.0225 6.00745 13.8471 6.06681 14.3849 6.53973C15 7.08053 15 7.95093 15 9.69173V10.3072C15 12.048 15 12.9184 14.3849 13.4592C13.7698 14 12.7799 14 10.8 14H5.2C3.2201 14 2.23015 14 1.61508 13.4592C1 12.9184 1 12.048 1 10.3072L1 9.69173C1 7.95093 1 7.08053 1.61508 6.53973C2.15294 6.06681 2.97748 6.00745 4.5 6",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10L8 1M8 1L11 3.42308M8 1L5 3.42308",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutputLang);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/output_lang.c402e02b6223a6809ec56d901612fa1a.svg";